export enum GeoTestType {
  holdout = 'HOLDOUT',
  scale = 'SCALE',
  lift = 'LIFT'
}
